/** Fade out the static HTML loader once React is ready. */
export function dismissInitialLoader(): void {
  const el = document.getElementById('initial-loader');
  if (!el) return;

  el.classList.add('tropayment-loader-screen--hide');
  window.setTimeout(() => el.remove(), 480);
}
